export const weekays = [
    {
        id: 'MO',
        name: 'Lunes',
    },
    {
        id: 'TU',
        name: 'Martes',
    },
    {
        id: 'WE',
        name: 'Miércoles',
    },
    {
        id: 'TH',
        name: 'Jueves',
    },
    {
        id: 'FR',
        name: 'Viernes',
    },
    {
        id: 'SA',
        name: 'Sábado',
    },
    {
        id: 'SU',
        name: 'Domingo',
    },
];
